const contactUs = [
    {
        "id": "1",
        "place": "台北總部辦公室",
        "name": "曾苑禎 小姐/蕭盈岑 小姐/陳欣樺 小姐",
        "phone": "02-2809-0828 分機29、25、26",
        "fax": "02-2809-0979",
        "email": "training@taftw.org.tw",
        "address": "25170 新北市淡水區中正東路二段27號23樓"
    },
    {
        "id": "2",
        "place": "新竹分部辦公室",
        "name": "陳羿安 小姐",
        "phone": "03-5336333 分機 245",
        "fax": "03-5358662",
        "email": "training@taftw.org.tw",
        "address": "30044 新竹市北大路95號2樓"
    }
];

export default contactUs;